module.exports = __webpack_public_path__ + "img/dm.04ef501a.svg";